import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MatTable } from '@angular/material/table'
import { SharedCustomersService } from 'src/app/shared/services/customers/customers.service';
import { LocationService } from 'src/app/shared/services/location/location.service';
import { NotificationService } from '../../services/notification.service';
import { map, startWith, tap } from 'rxjs/operators';
import { SnackBarService } from 'src/app/shared';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
@Component({
  selector: 'app-create-group',
  templateUrl: './create-group.component.html',
  styleUrls: ['./create-group.component.scss']
})
export class CreateGroupComponent implements OnInit {

  createGroupForm:FormGroup=new FormGroup({})
  filterForm:FormGroup
  // customerControl = new FormControl('', [Validators.required]);
  selectedCustomers: any[] = new Array<any>();
  lastFilter: string = '';
  filteredCustomers: Observable<any[]>;
  availableCustomers: any[];
  selectedCustomersIDs: number[] = [];
  countries:any[]
  groupId:any
  isEditingMode:boolean=false
  groupDetail:any;
  officesList:any;
  customersList:any
  allCustomersList: any;
  panelOpenState: boolean = true;
  customersDisplayedColumns = ['checkbox', 'name', 'email', 'customerCode']
  selectedCustomersDisplayedColumns = ['checkbox', 'name', 'customerCode']
  customerList:any;
  checkCustomer:boolean=false;
  @ViewChild('selectedTable') table: MatTable<any>;

  pageSizeOptions: number[] = [
    25,
    50,
    100,
    200,
    500
  ]
  pageSize: number = this.pageSizeOptions[0];
  pageIndex : number = 0;
  pageOffset: number = 0;

  constructor(
    private notificationService:NotificationService,
    private activatedRoute:ActivatedRoute,
    private locationService:LocationService,
    private sharedCustomersService:SharedCustomersService,
    private snackbarservice:SnackBarService,
    private router:Router,
    private gaService:GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this.initForm();
    this.setRouteParam();
    this.getCountryLists();
    this.getOfficesList();
  }

  initForm(){
    this.createGroupForm=new FormGroup({
      name:new FormControl('',Validators.required),
    })

    this.filterForm=new FormGroup({
      city__state__country:new FormControl(''),
      active:new FormControl(true),
      search:new FormControl(''),
      office:new FormControl('')
    })
  }

  setRouteParam(){
    this.activatedRoute.params.subscribe(params=>{
      this.groupId=params.id ? params.id : ''
    })
    if(this.groupId){
      this.isEditingMode=true
      this.notificationService.getNotificationGroupDetail(this.groupId).subscribe(data=>{
        this.groupDetail=data
        this.fillCustomerSelectList()
        this.setGroupData();
        this.getCustomersList();
      })
    }
    else{
      this.getCustomersList();
    }
  }

  getOfficesList(){
    this.notificationService.getOfficesList({limit:1000}).subscribe(data=>{
      this.officesList=data.results
    })
  }

  // setGroupData(){
  //   if(this.isEditingMode){
  //     this.createGroupForm.controls.name.patchValue(this.groupDetail.name)
  //     let customers:any[]=[]
  //     this.groupDetail.members.forEach(element => {
  //       this.customersList.filter(customer=>{
  //         if(customer.id === element){
  //           customers.push(customer)
  //         }
  //       })
  //     });
  //     this.selectedCustomers=customers;
  //     this.customerControl.setValue(this.selectedCustomers);
  //   }
  // }

  setGroupData(){
    if(this.isEditingMode){
      this.createGroupForm.controls.name.patchValue(this.groupDetail.name)
      this.getAllCustomers()
    }
  }

  // createGroup(){
  //   let members=[]
  //   this.customerControl.value.forEach(element => {
  //     members.push(element.id)
  //   });
  //   let params={
  //     name: this.createGroupForm.get('name').value,
  //     members: members
  //   }
  //   if(this.isEditingMode){
  //     this.notificationService.updateNotificationGroup(this.groupId,params).subscribe(
  //       success=>{
  //       this.snackbarservice.showSnack('notification group updated successfuly.')
  //       this.router.navigate(['/notifications/groups'])
  //       },
  //       error=>{
  //         this.snackbarservice.showSnack(error.error.detail)
  //       }    
  //     )
  //   }
  //   else{
  //     this.notificationService.createNotificationGroup(params).subscribe(
  //       success=>{
  //       this.snackbarservice.showSnack('notification group created successfuly.')
  //       this.router.navigate(['/notifications/groups'])
  //       },
  //       error=>{
  //         this.snackbarservice.showSnack(error.error.detail)
  //       }    
  //     )
  //   }
  // }


  createGroup(){
    let members:any[]=[]
    this.selectedCustomers.forEach(element => {
      members.push(element.user_id)
    });
    let params={
      name: this.createGroupForm.get('name').value,
      members: members
    }
    if(this.isEditingMode){
      this.notificationService.updateNotificationGroup(this.groupId,params).subscribe(
        success=>{
        this.snackbarservice.showSnack('notification group updated successfuly.')
        this.router.navigate(['/notifications/groups'])
        },
        error=>{
          this.snackbarservice.showSnack(error.detail)
        }    
      )
    }
    else{
      this.notificationService.createNotificationGroup(params).subscribe(
        success=>{
        this.snackbarservice.showSnack('notification group created successfuly.')
        this.router.navigate(['/notifications/groups'])
        },
        error=>{
          this.snackbarservice.showSnack(error.detail)
        }    
      )
    }
  }

  getCountryLists(){
    this.locationService.getCountryList('',false).subscribe(data=>{
      this.countries=data.results
    })
  }


  onSubmitFilterForm(){ 
    this.getCustomersList(true);
  }

  onPaginateChange($event) {
    this.pageIndex = $event.pageIndex;
    this.pageSize = $event.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getCustomersList();
  }

  getCustomersList(reset:boolean = false) {
    if(reset) {
      this.pageOffset = 0
    }
    if(this.filterForm.controls.search.value){
      try{
        this.gaService.sendAnalytics('search',{search_term:this.filterForm.controls?.search?.value})
      }
      catch{}
    }
    this.sharedCustomersService.getCustomers(this.pageSize,this.pageOffset,this.filterForm.controls.search.value,this.filterForm.controls.active.value,{city__state__country:this.filterForm.controls.city__state__country.value,office:this.filterForm.controls.office.value}).subscribe(
      success => {
        this.customerList=success;
        if(this.customerList.results.length && this.filterForm.controls.search.value){
          let result:any[]=this.customerList.results.map(item=>{
            return {id:item.id,name:item.company}
          })
          try{
            let searchResults={
              term:this.filterForm?.controls?.search?.value,
              items:result? result : ""
            }
            this.gaService.sendAnalytics('view_search_results',searchResults)
          }
          catch{}
        }
      }
    )
  }

  getAllCustomers() {
    this.sharedCustomersService.getCustomers(10000,0,this.filterForm.controls.search.value,this.filterForm.controls.active.value,{city__state__country:this.filterForm.controls.city__state__country.value,office:this.filterForm.controls.office.value}).subscribe(
      success => {
        this.allCustomersList=success.results;
        this.fillCustomerSelectList();
      }
    )
  }

  fillCustomerSelectList() {
    if(this.allCustomersList && this.groupDetail) {
      if(this.isEditingMode){
        for(let member of this.groupDetail.members) {
          let c = this.allCustomersList.find(customer=> customer.user_id === member)
          if(c) {
            this.selectedCustomers.push(c)
            this.selectedCustomersIDs.push(c.user_id)
          }
        };
        this.table.renderRows()
      }
    }
  }
  filter(filter: string): any[] {
    this.lastFilter = filter;
    if (filter) {
      return this.availableCustomers.filter(option => {
        return option.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0
      })
    } else {
      return this.availableCustomers.slice();
    }
  }

  displayFn(value: any[] | string): string | undefined {
    let displayValue: string;
    if (Array.isArray(value)) {
      value.forEach((customer, index) => {
        if (index === 0) {
          displayValue = customer.name;
        } else {
          displayValue += ', ' + customer.name;
        }
      });
    } else {
      displayValue = value;
    }
    return displayValue;
  }

  optionClicked(event: Event, customer: any) {
    event.stopPropagation();
    this.toggleSelection(customer);
  }

  toggleSelection(id) {
    let i = this.selectedCustomers.indexOf(id)
    if(i != -1) {
      this.selectedCustomers.splice(i, 1);
    } else {
      this.selectedCustomers.push(id)
    }
  }

  isCustomerSelected(id) {
    return this.selectedCustomers.indexOf(id) != -1
  }


  addCustomer(customer) {
    if(this.selectedCustomers.indexOf(customer) == -1) {
      this.selectedCustomers.push(customer);
      this.selectedCustomersIDs.push(customer.user_id);
      this.table.renderRows()
    }
  }

  removeCustomer(index) {
    this.selectedCustomers.splice(index, 1);
    this.selectedCustomersIDs.splice(index, 1);
    this.table.renderRows();
  }
}
